import { axiosInstance } from "@/helper/axios-instance";
import { DataAwareResponse } from "../types/types";
import { useMutationWithValidation } from "./useMutationWithValidation";

type UpdateLockeNPVReq = {
  externalCode: string;
  lockedNPV: number | null;
};

export function useUpdateNpvLockedValue(isLocking: boolean) {
  return useMutationWithValidation<boolean, UpdateLockeNPVReq>({
    mutationFn: async (data: UpdateLockeNPVReq) => {
      const url = isLocking
        ? 
          `Salesforce/UpdateNPVLockedValue/${data.externalCode}?lockedNPV=${data.lockedNPV}`
        :  `Salesforce/UpdateNPVLockedValue/${data.externalCode}`;

      const response = await axiosInstance({
        method: "PUT",
        url,
      });

      return response.data as DataAwareResponse<boolean>;
    },
  });
}
